/**
 * @desc: 工具- 线路测速
 * @param  {[STRING]}
 * @param  {[bool]}
 * @param  {[function]}
 * @author: Klaf
 * example:
 *  speedDomains =
      { "data": {
          "1": [
            "jet3.com",
            "jet2.com",
          ],
          "2": [
            "test5.com",
            "test4.com",
          ],
          "3": [
            "www.heller.com",
            "www.sincai.com",
          ],
          "4": [
            "test7.com",
            "test8.com",
          ]
      }
  }

  <SpeedTest domains={speedDomains} />
 */
import React from 'react';

export default class SpeedTest extends React.Component {

  constructor(props) {
    super(props);
    this.actionTest = this.actionTest.bind(this);
    this.state = {
      testDone: false,
      testTimer: [],
      displayDomain: null
    }
    this.allImages = [];
  }

  componentDidMount(){
    if (!this.props.domains) {
      return;
    }
    this.actionTest(this.props.domains)
  }

  componentWillUnmount(){
    _.each(this.allImages, function(domainIMG, index){
      domainIMG.removeEventListener('load', this.handleOnLoad, false)
      domainIMG.removeEventListener('error', this.handleOnError, false)
    }.bind(this))
  }

  // 非初始化，从父级接收到prop改变时
  componentWillReceiveProps(nextProps) {
    const nextDomains = nextProps.domains;
    const thisDomains = this.props.domains;
    if (!thisDomains && nextDomains){
      this.actionTest(nextDomains);
    }
  }

  shouldComponentUpdate(nextProps, nextState){
    const testedDomains = _.chain(nextState.testTimer).filter((item) => item.status).sortBy('wasteTime').unionBy('key').value()
    if(testedDomains.length == 4){
      //nextState.testDone = true;
      nextState.displayDomain = testedDomains

      // _.each(testedDomains, function(v,i){
      //   let levelSum = testedDomains[0].wasteTime+testedDomains[1].wasteTime+testedDomains[2].wasteTime+testedDomains[3].wasteTime;
      //   let level = parseInt((1 - v.wasteTime/levelSum)*100);
      //   let levelOn = level - (parseInt((1 - testedDomains[1].wasteTime/levelSum)*100) - 8);
      //       i == 1 ? (levelOn<8 ? levelOn=7 : levelOn) : levelOn<4 ? levelOn=3 : levelOn;
      //   _.times(10, (n) => levelOn < n ? testedDomains[i].classNames[n]='' : testedDomains[i].classNames[n]='testLevel' )
      // })
    }

    return true;
  }

  // 重新测试
  reTest(){
    this.setState({
      testDone: false,
      testTimer: [],
      displayDomain: null
    })
    this.actionTest(this.props.domains);
  }

  // 开始测速
  actionTest(domains){
    _.each(domains, function(domain, index){
      let tested = {
        beginTime: new Date().getTime(),
        domain: domain.domain,
        key: domain.key,
        index: domain.index,
        classNames: []
      }
      let domainIMG = new Image();

      domainIMG.addEventListener('load', this.handleOnLoad.bind(this,tested))
      domainIMG.addEventListener('error', this.handleOnError.bind(this,tested))

      domainIMG.src = window.location.protocol  + '//' + domain.domain + '/point.bmp?r=' + _.random(999999);

      this.allImages.push(domainIMG)

    }.bind(this))
  }

  handleOnLoad(tested){
    tested.wasteTime = new Date().getTime() - tested.beginTime;
    tested.status = true;
    let newTimers = _.cloneDeep(this.state.testTimer);
    newTimers.push(tested);
    this.setState({
      testTimer: newTimers
    })
  }

  handleOnError(tested){
    tested.wasteTime = new Date().getTime() - tested.beginTime;
    tested.status = false;
    let newTimers = _.cloneDeep(this.state.testTimer);
    newTimers.push(tested);
  }


  render() {
    const { handleNoChange } = this.props;
    return (
      <div className="speed-test-containers">
        <fieldset className="speedtest">
          <legend>推荐最优线路</legend>
          {
            this.state.displayDomain ?
              <a className="changeUrl pointer" onClick={handleNoChange.bind(this, this.state.displayDomain[0].domain)}>一键切换最优线路</a>
            : <a className="changeUrl pointer" onClick={handleNoChange.bind(this,false)}>一键切换最优线路</a>
          }
        </fieldset>
      </div>
    );
  }
}
